// eslint-disable-next-line import/prefer-default-export
export const calculateExportToastTitle = (title, exportType = '') => {
  if (exportType === 'app') {
    return `Deployment ${title}`;
  }

  if (exportType === 'full') {
    return `Full ${title}`;
  }

  if (exportType === 'nlu') {
    return `NLU ${title}`;
  }

  return title;
};

export const calculateFullNameDotFormat = (firstName = '', lastName = '') =>
  firstName.length > 0 && lastName.length > 0
    ? `${firstName.charAt(0).toUpperCase()}.${lastName
        .charAt(0)
        .toUpperCase()}${lastName.substring(1)}`
    : '';
